import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
  light?: boolean;
};
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-lg border px-4 py-2 font-mono font-black ${light ? 'border-gold-500/50 bg-forest-900 text-cream' : 'border-earth-200 bg-white text-forest-950'} ${className}`} aria-label="Tiempo restante de la oferta" data-id="element-265" data-mp="1xfs30k0p6rmm">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-266" data-mp="34sk1j41qd0bk" data-mpi={index}>
          {index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-267" data-mp="34vod4mhiyyc9">:</span>}
          <span className="flex min-w-[38px] flex-col items-center leading-none" data-id="element-268" data-mp="2c6lyhej1sa63">
            <b className="text-xl" data-id="element-269" data-mp="2h5yuaorwcrkt">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-270" data-mp="2l8bwx4bck9dd">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}